export var actionNames = {
    DeleteConversationStoreUpdate: 'deleteConversationStoreUpdate',
    EmptyFolderStoreUpdate: 'emptyFolderStoreUpdate',
    DeleteFolderAction: 'deleteFolderAction',
    ForwardMessageAction: 'forwardMessageAction',
    LoadDraftToComposeAction: 'loadDraftToComposeAction',
    MarkAllAsReadStoreUpdate: 'markAllAsReadStoreUpdate',
    MarkConversationsAsPinned: 'markConversationsAsPinned',
    ReloadMailListTableAction: 'reloadMailListTableAction',
    SingleMailItemSelectedAction: 'singleMailItemSelectedAction',
    ToggleConversationPinState: 'toggleConversationPinnedState',
    SendFeedbackActionName: 'SendFeedbackAction',
};
//# sourceMappingURL=actionTypes.js.map